import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { I18n } from 'react-redux-i18n-lite';
import { bindActionCreators } from 'redux';
import * as classroomActions from '../../../actions/classroom/classroomActions';
import { editRoleClassroom } from '../../../services/api/participantsApi';
import { Modal, Button, Paragraph } from '@netexknowledge/smart-components';

class EditRoleClassroomReveal extends React.Component {
  editRoleClassroomHandler = async () => {
    const {
      selectedUser: { _id, role },
      selectedClassroomId,
      participants,
      classroomActions
    } = this.props;

    const modifiedParticipant = await editRoleClassroom(selectedClassroomId, _id, role).then(res => res.data);

    const modifiedParticipants = participants.map(participant =>
      participant._id !== modifiedParticipant._id ? participant : modifiedParticipant
    );

    classroomActions.setClassroomParticipants(modifiedParticipants);
    this.closeEditRoleModal();
  };

  closeEditRoleModal = () => {
    const { classroomActions } = this.props;
    classroomActions.setEditRoleModalState(false);
  };

  render() {
    const { active } = this.props;

    return (
      <Modal
        id="editRole"
        title={I18n.t('participants.modal.reveal.editRole.title')}
        active={active}
        onClickOutside={this.closeEditRoleModal}
        children={<Paragraph className="text-grey-700">{I18n.t('participants.modal.reveal.editRole.text')}</Paragraph>}
        footer={
          <>
            <Button onClick={this.closeEditRoleModal} label={I18n.t('common.cancel')}></Button>
            <Button
              onClick={this.editRoleClassroomHandler}
              primary
              label={I18n.t('importStudentsPopup.change')}
            ></Button>
          </>
        }
      ></Modal>
    );
  }
}

EditRoleClassroomReveal.propTypes = {
  active: PropTypes.bool,
  classroomActions: PropTypes.object,
  colors: PropTypes.object,
  selectedUser: PropTypes.object,
  selectedClassroomId: PropTypes.string,
  participants: PropTypes.array
};

function mapStateToProps(state) {
  return {
    active: state.classrooms.editRoleModalIsOpen,
    selectedUser: state.student.selectedStudent,
    selectedClassroomId: state.classrooms.selectedClassroom.classroom.id,
    participants: state.classrooms.selectedClassroom.participants,
    colors: state.theme.colors,
    i18n: state.i18n
  };
}

function mapDispatchToProps(dispatch) {
  return {
    classroomActions: bindActionCreators(classroomActions, dispatch),
    dispatch
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(EditRoleClassroomReveal);
